const config = {
  IMG_URL: 'https://tuly.app/',
  LOCAL_URL: 'http://localhost:3000/',
  GLD_IMG_URL: "http://localhost:5000/images/",
  //GLD_IMG_URL: "https://tuly.app/api/images/gen_images/"
};

export default config;